import { notificationConstants } from "../constants/notificationConstants";

const initiaState = {
  isLoading: false,
  notifications: [],
  response: {
    state: null,
    message: "",
  },
};

const notificationReducer = (state = initiaState, action) => {
  console.log("action", action);
  switch (action.type) {
    case notificationConstants.LOADING:
      return {
        ...state,
        isLoading: action?.isLoading,
      };

    case notificationConstants.GET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action?.payLoad?.notifications,
      };
    case notificationConstants.RESPONSE_STATE:
      return {
        ...state,
        response: {
          state: action?.response?.state,
          message: action?.response?.message,
        },
      };

    default:
      return state;
  }
};

export default notificationReducer;
